import React, { useState } from 'react';
import {
  Container,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Tabs,
  Tab,
  Fade,
} from '@mui/material';
import {
  KeyboardArrowDown,
  HeadsetMicOutlined,
} from '@mui/icons-material';

const faqs = [
  {
    category: 'Inscrição e participação em turmas',
    items: [
      {
        question: 'Como escolho uma turma para participar?',
        answer:
          'Acesse a seção "Turmas" e consulte as edições disponíveis. Compare a modalidade, o período de realização, as datas presenciais, quando houver, e o prazo de inscrição. Depois, selecione a turma mais adequada à sua disponibilidade e confirme.',
      },
      {
        question:
          'Como sei se minha inscrição foi registrada e se minha vaga está garantida?',
        answer:
          'Após selecionar a turma, sua inscrição será registrada automaticamente e você receberá um e-mail com a confirmação do cadastro e a situação da sua participação.\nO registro da inscrição não significa necessariamente que a vaga já esteja confirmada. A matrícula só será efetivada após a convocação e a confirmação dentro do prazo informado. Cada turma regular possui limite de participantes.',
      },
      {
        question: 'Como funciona a lista de espera e a ordem de convocação?',
        answer:
          'Quando todas as vagas estiverem pré-ocupadas, os novos inscritos entram automaticamente na lista de espera. A fila é organizada conforme a ordem de inscrição.\nCaso uma pessoa convocada não confirme a matrícula no prazo, a vaga será oferecida ao próximo participante da fila.',
      },
      {
        question:
          'Quando receberei a convocação e quanto tempo terei para confirmar minha vaga?',
        answer:
          'O processo de confirmação começa uma semana antes da data prevista para o início da turma. Os participantes convocados recebem um e-mail com o link para confirmar a matrícula.\nA partir do envio, você terá 48 horas para confirmar sua participação. Caso a confirmação ainda esteja pendente, um lembrete será enviado após 24 horas.',
      },
      {
        question: 'O que acontece se eu não confirmar dentro do prazo?',
        answer:
          'Se a confirmação não for realizada em até 48 horas, o link expirará e a reserva da vaga será cancelada. A vaga será então oferecida automaticamente ao próximo participante da lista de espera.\nNovas convocações serão realizadas somente até 48 horas antes do início da turma. Após esse prazo, a fila será encerrada para essa edição do curso, exceto se ainda houver vagas disponíveis. Nesse caso, as inscrições permanecerão abertas até 48 horas após a data de início da turma.',
      },
      {
        question: 'Posso trocar de turma depois de me inscrever?',
        answer:
          'A possibilidade de troca dependerá da disponibilidade de vagas e da situação da sua inscrição. Após se inscrever, você permanecerá vinculado à turma escolhida. A troca só poderá ser realizada quando houver outra turma disponível para inscrição na plataforma.',
      },
      {
        question: 'Por que ainda não consigo acessar os módulos?',
        answer:
          'Os módulos podem permanecer indisponíveis quando:\n- sua matrícula ainda não foi confirmada;\n- a turma ainda não iniciou;\n- o período de acesso aos conteúdos ainda não foi aberto;\n- o módulo anterior ou algum pré-requisito obrigatório ainda não foi concluído.\nNa modalidade híbrida, os conteúdos finais também podem depender da conclusão dos módulos teóricos e do registro de presença nas etapas presenciais.',
      },
    ],
  },
  {
    category: 'Conteúdos, navegação e progresso',
    items: [
      {
        question: 'Onde encontro meu curso, os módulos e a próxima atividade?',
        answer:
          'Após entrar na plataforma, acesse a página inicial ou a área "Minha turma". Nela, você encontrará o curso, os módulos disponíveis, seu progresso e a próxima atividade recomendada.',
      },
      {
        question: 'Como acompanho meu progresso na capacitação?',
        answer:
          'O progresso pode ser acompanhado na página inicial ou na página interna dos conteúdos do curso. A plataforma mostra os módulos concluídos, a etapa em andamento e as atividades que ainda precisam ser realizadas.',
      },
      {
        question:
          'Por que é recomendado realizar o Módulo 0 e posso acessá-lo novamente?',
        answer:
          'O Módulo 0 apresenta o curso, funcionamento da plataforma e os comandos de navegação no Ambiente Virtual 3D. Por isso, recomendamos concluí-lo antes de iniciar os conteúdos técnicos.\nEle poderá ser acessado novamente sempre que você precisar consultar as orientações de uso da plataforma ou do simulador.',
      },
      {
        question:
          'Como funciona a sequência dos módulos e o desbloqueio das próximas etapas?',
        answer:
          'Os módulos seguem uma ordem progressiva. Para avançar, é necessário concluir os conteúdos, as atividades práticas e a avaliação obrigatória da etapa anterior.\nNa modalidade híbrida, os módulos 4 e 5 também dependem da conclusão dos módulos teóricos iniciais e do registro de presença realizado pelo professor.',
      },
      {
        question: 'Posso rever aulas e módulos já concluídos?',
        answer:
          'Sim. Enquanto o conteúdo estiver disponível para sua turma, você poderá acessar novamente as videoaulas, os materiais de apoio e os módulos já concluídos para revisar os conteúdos.',
      },
      {
        question:
          'As aulas são ao vivo ou gravadas e posso assisti-las em qualquer horário?',
        answer:
          'Na modalidade remota, as videoaulas são gravadas e podem ser assistidas em qualquer dia ou horário, desde que você respeite o período definido para a realização da turma.\nNa modalidade híbrida, também existem conteúdos assíncronos, além de atividades síncronas ou presenciais em datas estabelecidas no cronograma.',
      },
      {
        question: 'Preciso assistir à videoaula inteira para concluir a etapa?',
        answer:
          'Sim. Para que a videoaula seja registrada como concluída, é necessário assistir ao conteúdo conforme as regras de acompanhamento da plataforma.\nNa modalidade híbrida, as videoaulas correspondentes aos módulos presenciais poderão ser marcadas automaticamente como concluídas após o registro de presença pelo professor.',
      },
      {
        question:
          'Onde encontro os materiais de apoio e eles substituem as videoaulas?',
        answer:
          'Os materiais de apoio ficam disponíveis dentro de cada módulo, junto às videoaulas e atividades relacionadas.\nEles complementam os conteúdos apresentados, mas não substituem as videoaulas, as práticas no simulador ou as avaliações obrigatórias.',
      },
      {
        question: 'Quais são os prazos para concluir os módulos e o curso?',
        answer:
          'Os prazos são definidos de acordo com o cronograma de cada turma e podem ser consultados na página inicial ou nos detalhes da turma.\nNa modalidade híbrida, os módulos 1, 2 e 3 devem ser totalmente concluídos dentro da janela de nivelamento definida antes dos encontros presenciais.',
      },
      {
        question:
          'Os conteúdos permanecem disponíveis após o encerramento da turma?',
        answer:
          'A disponibilidade dos conteúdos após o encerramento depende das regras definidas para cada turma. Consulte as informações da sua edição ou entre em contato com o suporte.',
      },
      {
        question: 'Posso acessar a plataforma pelo celular ou tablet?',
        answer:
          'A plataforma web poderá ser acessada por dispositivos móveis, desde que o navegador seja compatível. Entretanto, algumas atividades, especialmente as realizadas no ambiente virtual da planta, podem exigir uma tela maior, teclado, mouse e conexão estável.\nPara uma melhor experiência no ambiente virtual, recomenda-se utilizar um computador ou notebook.',
      },
      {
        question:
          'Quais navegadores são recomendados e o que fazer se uma página não carregar?',
        answer:
          'Para uma melhor experiência, utilize as versões mais recentes do Google Chrome ou do Microsoft Edge.\nCaso uma página não carregue:\n- atualize a página;\n- verifique sua conexão;\n- limpe o cache do navegador;\n- tente acessar em uma janela anônima ou em outro navegador;\n- se o problema continuar, entre em contato com o suporte.',
      },
    ],
  },
  {
    category: 'Ambiente Virtual 3D e atividades práticas',
    items: [
      {
        question: 'O que é o Ambiente Virtual 3D?',
        answer:
          'O Ambiente Virtual 3D é um simulador imersivo que representa a planta e o reator Fischer–Tropsch. Nele, você poderá navegar pela unidade, identificar equipamentos e instrumentos, consultar o sistema supervisório e realizar atividades práticas de operação, segurança e manutenção.',
      },
      {
        question:
          'Preciso instalar algum programa e quais são os requisitos técnicos para acessar o simulador?',
        answer:
          'Não é necessário instalar o simulador. O acesso é realizado diretamente pela plataforma web.\nPara utilizar o ambiente, você precisará de:\n- computador ou notebook;\n- navegador atualizado;\n- conexão de banda larga estável;\n- teclado e mouse para navegação e interação.',
      },
      {
        question: 'Posso utilizar o simulador pelo celular ou tablet?',
        answer:
          'O acesso pelo navegador de dispositivos móveis pode ser tecnicamente possível, mas não é recomendado para a realização das atividades práticas.\nPara uma experiência mais adequada, utilize um computador ou notebook, pois o simulador exige navegação em ambiente 3D, interação com equipamentos e uso de comandos por teclado e mouse.',
      },
      {
        question:
          'O simulador salva meu progresso e o que acontece em caso de desconexão?',
        answer:
          'O simulador não realiza salvamentos intermediários durante as atividades práticas. Caso ocorra uma desconexão antes da conclusão, será necessário acessar novamente o ambiente e reiniciar a atividade desde o início.',
      },
      {
        question: 'Por que fui colocado em uma fila para acessar o simulador?',
        answer:
          'O simulador permite o acesso simultâneo de até dois participantes. Caso as duas sessões estejam em uso, você será direcionado automaticamente para uma fila e deverá aguardar até que um acesso seja liberado.',
      },
      {
        question: 'O que devo fazer se o simulador estiver lento ou não carregar?',
        answer:
          'Verifique se sua conexão com a internet está estável, atualize a página e feche abas ou programas que possam estar consumindo a rede. Se o problema continuar, entre em contato com o suporte.',
      },
      {
        question: 'Posso reiniciar ou repetir uma atividade prática?',
        answer:
          'Sim. Você poderá reiniciar ou repetir as atividades práticas disponíveis para revisar os procedimentos e aperfeiçoar sua execução.',
      },
      {
        question:
          'Existe limite de tentativas ou de tempo para concluir uma simulação?',
        answer:
          'O limite dependerá do tipo de atividade. Práticas de treinamento podem permitir novas execuções, enquanto atividades avaliativas podem possuir quantidade de tentativas ou prazo definidos.',
      },
      {
        question: 'O que devo fazer se não conseguir concluir uma prática?',
        answer:
          'Revise as orientações da atividade, consulte os materiais de apoio e verifique se todas as etapas do procedimento foram realizadas na ordem indicada. Se a dificuldade continuar, entre em contato com o suporte.',
      },
    ],
  },
  {
    category: 'Avaliações',
    items: [
      {
        question: 'Como funcionam as avaliações e elas são obrigatórias?',
        answer:
          'Ao final de cada módulo, você realizará uma avaliação teórica na plataforma, composta por questões objetivas de múltipla escolha. As avaliações verificam a compreensão dos conteúdos apresentados nas videoaulas, nos materiais de apoio e nas atividades práticas do simulador.\nSim. A aprovação nas avaliações de todos os módulos é obrigatória para avançar na trilha e receber o certificado.',
      },
      {
        question: 'Qual é a nota mínima para aprovação?',
        answer:
          'A nota mínima depende do tipo de inscrição e é informada antes do início da avaliação de cada módulo. Para avançar para o próximo módulo, é necessário atingir a nota mínima exigida.',
      },
      {
        question: 'Quantas tentativas estão disponíveis?',
        answer:
          'Você terá até três tentativas por avaliação para alcançar a nota mínima exigida. Antes de realizar uma nova tentativa, recomendamos revisar as aulas e os materiais de apoio do módulo.',
      },
      {
        question:
          'Quando receberei o resultado e poderei visualizar as questões que errei?',
        answer:
          'O resultado será apresentado pela plataforma após o envio da avaliação. Nessa área, você poderá consultar sua nota e verificar se atingiu o aproveitamento necessário para avançar.',
      },
      {
        question: 'O que acontece se eu não atingir a nota mínima?',
        answer:
          'Caso não alcance a nota mínima, você poderá revisar os conteúdos e realizar uma nova tentativa, respeitando o limite de três tentativas.\nSe não atingir a nota exigida após a terceira tentativa, você será reprovado naquele módulo. O progresso desse módulo será reiniciado, e será necessário refazer todas as suas etapas antes de realizar novamente a avaliação.',
      },
      {
        question: 'Uma falha de conexão durante a avaliação conta como tentativa?',
        answer:
          'Sim. Se ocorrer uma falha de conexão durante a avaliação, a tentativa será contabilizada e as respostas registradas até aquele momento serão enviadas. Caso a nota obtida seja inferior à mínima exigida, a tentativa será perdida.\nNão será possível retomar a avaliação do ponto em que ela foi interrompida. Essa condição é informada claramente antes do início da avaliação.',
      },
    ],
  },
  {
    category: 'Certificado',
    items: [
      {
        question: 'Quais são os critérios para receber o certificado?',
        answer:
          'Para receber o certificado, você deverá concluir toda a trilha de conteúdos. Também é necessário finalizar todas as etapas dentro do período de vigência da turma. Na modalidade híbrida, o participante deve cumprir os pré-requisitos e ter a presença registrada nas atividades presenciais obrigatórias.',
      },
      {
        question:
          'Quando o certificado será disponibilizado e onde posso encontrá-lo?',
        answer:
          'O certificado será liberado após a conclusão de todos os módulos. Depois de disponível, ele poderá ser acessado na área "Certificado" da plataforma, localizada em "Minha área", ou na página do próprio curso, na seção que apresenta a trilha de aprendizagem.',
      },
      {
        question: 'O certificado possui código de autenticidade?',
        answer:
          'Sim. O certificado contará com um código único de identificação, que poderá ser utilizado para verificar sua autenticidade.',
      },
      {
        question: 'Posso compartilhar meu certificado no LinkedIn?',
        answer:
          'Sim. Acesse "Minha área", entre na seção "Certificado" e abra o documento emitido. Nessa página, utilize o atalho de compartilhamento para adicionar o certificado ao seu perfil do LinkedIn diretamente.',
      },
      {
        question: 'Posso emitir o certificado novamente caso perca o arquivo?',
        answer:
          'Sim. Enquanto o certificado estiver disponível na sua conta, você poderá acessá-lo novamente pela área "Certificado" e gerar uma nova cópia.',
      },
      {
        question:
          'O certificado continuará disponível depois do encerramento da turma?',
        answer:
          'Sim. Após ser emitido, o certificado permanecerá disponível na sua conta mesmo depois do encerramento da turma, permitindo novos acessos e emissões quando necessário.',
      },
    ],
  },
  {
    category: 'Modalidades',
    items: [
      {
        question: 'Qual é a diferença entre as modalidades remota e híbrida?',
        answer:
          'Na modalidade remota, todo o percurso é realizado online, por meio de videoaulas gravadas, materiais de apoio, avaliações e atividades no simulador virtual. O participante pode organizar seus estudos com flexibilidade, desde que respeite o período definido para a turma.\nNa modalidade híbrida, parte da capacitação também ocorre online, mas os módulos finais incluem encontros presenciais em datas previamente definidas.',
      },
      {
        question: 'Quais etapas da modalidade híbrida exigem presença física?',
        answer:
          'Na modalidade híbrida, os Módulos 4 e 5 possuem etapas presenciais. As datas e demais orientações serão informadas no cronograma da turma.',
      },
      {
        question: 'O que preciso concluir antes do encontro presencial?',
        answer:
          'Você deverá concluir integralmente os Módulos 1, 2 e 3 dentro do período estabelecido para a etapa remota da turma.\nCaso os pré-requisitos não sejam concluídos no prazo, seu acesso às etapas presenciais será bloqueado e você ficará inapto a prosseguir naquela turma.',
      },
      {
        question: 'O que acontece se eu faltar ao encontro presencial?',
        answer:
          'Se você faltar, sua presença não será registrada e os materiais, as atividades e as avaliações correspondentes ao módulo presencial permanecerão bloqueados. Como essa etapa é obrigatória na modalidade híbrida, a ausência impedirá a continuidade da trilha e a conclusão da capacitação naquela turma.',
      },
      {
        question: 'Como minha presença será registrada?',
        answer:
          'No dia do encontro presencial, o professor fará a chamada diretamente pela plataforma. Somente os participantes que tiverem concluído os pré-requisitos estarão habilitados para receber presença. Após o registro, as videoaulas correspondentes ao módulo presencial serão marcadas automaticamente como concluídas, e os materiais, as atividades e as avaliações finais serão liberados na sua trilha.',
      },
    ],
  },
  {
    category: 'Prazos e encerramento',
    items: [
      {
        question: 'Qual é o período de realização da minha turma?',
        answer:
          'O período varia conforme o cronograma de cada turma. As datas de início e encerramento ficam disponíveis na página inicial. Na modalidade híbrida, também são apresentados os períodos da etapa remota e as datas dos encontros presenciais.',
      },
      {
        question: 'Todos os participantes possuem o mesmo prazo?',
        answer:
          'Sim. Os participantes de uma mesma turma devem concluir as etapas dentro do período definido para aquela edição. Na modalidade remota, cada pessoa pode organizar seus próprios dias e horários de estudo, mas deve respeitar a data final da turma. Na modalidade híbrida, também é necessário cumprir os prazos específicos da etapa remota e comparecer aos encontros presenciais nas datas programadas.',
      },
      {
        question: 'O prazo da turma pode ser prorrogado?',
        answer:
          'Não há prorrogação individual automática. Todos os participantes devem seguir o período estabelecido para a turma.\nCaso ocorra alguma alteração geral no cronograma, a nova data será comunicada oficialmente pela plataforma ou por e-mail.',
      },
      {
        question:
          'O que acontece com as atividades incompletas após o encerramento?',
        answer:
          'Após o encerramento, as atividades que não forem concluídas dentro do prazo deixam de contar para a progressão e para a conclusão da capacitação.\nNa modalidade híbrida, o participante que não concluir integralmente os Módulos 1, 2 e 3 dentro da janela definida ficará inapto a participar das etapas presenciais daquela turma.',
      },
      {
        question: 'Ainda posso acessar os conteúdos depois do fim da turma?',
        answer:
          'A disponibilidade dos conteúdos após o encerramento dependerá da regra de acesso adotada pela plataforma. Mesmo que alguns materiais permaneçam visíveis para consulta, atividades, avaliações e progressões podem ficar indisponíveis depois da data final.',
      },
      {
        question:
          'Posso participar de uma turma futura caso não consiga concluir?',
        answer:
          'Sim, desde que exista uma nova turma disponível para inscrição. A participação não será transferida automaticamente; será necessário selecionar a nova turma e passar novamente pelo processo de inscrição e confirmação de vaga.',
      },
    ],
  },
];

const CentralAjudaPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const currentCategory = faqs[activeTab];

  return (
    <Fade in={true} timeout={800}>
      <Box sx={{ backgroundColor: '#FAFAFA', minHeight: '100vh', pt: 16, pb: 8 }}>
        <Container maxWidth='xl'>
        {/* Header */}
        <Box sx={{ mb: 2 }}>
          <Typography
            variant='h4'
            fontWeight='800'
            sx={{ color: '#0A2540', mb: 1 }}
          >
            Dúvidas frequentes
          </Typography>
          <Typography variant='body1' sx={{ color: '#6B778C' }}>
            Respostas rápidas para as principais dúvidas da sua turma.
          </Typography>
        </Box>

        {/* Tabs */}
        <Box sx={{ mb: 4 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant='scrollable'
            scrollButtons='auto'
            TabIndicatorProps={{ sx: { display: 'none' } }}
            sx={{
              minHeight: 'auto',
              '& .MuiTabs-flexContainer': {
                gap: 1.5,
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                minHeight: 42,
                borderRadius: '24px',
                border: '1px solid #D0D5DD',
                bgcolor: '#fff',
                color: '#344054',
                fontWeight: 600,
                fontSize: '0.875rem',
                px: 2.5,
                py: 0.5,
                transition: 'all 0.2s ease',
                '&.Mui-selected': {
                  bgcolor: '#E6F7F8',
                  color: '#0097A7',
                  border: '1.5px solid #0097A7',
                },
                '&:hover': {
                  bgcolor: '#F0F4F8',
                },
              },
            }}
          >
            {faqs.map((section, index) => (
              <Tab key={index} label={section.category} />
            ))}
          </Tabs>
        </Box>

        {/* FAQ Accordions for active tab */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #EAEAEA',
            borderRadius: '12px',
            overflow: 'hidden',
          }}
        >
          {currentCategory.items.map((faq, index) => (
            <Accordion
              key={index}
              elevation={0}
              disableGutters
              square
              sx={{
                borderTop: index === 0 ? 'none' : '1px solid #EAEAEA',
                '&:before': { display: 'none' },
              }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDown />}
                sx={{
                  '& .MuiAccordionSummary-content': { my: 2 },
                  bgcolor: '#fff',
                }}
              >
                <Typography fontWeight='700' sx={{ color: '#0A2540' }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  bgcolor: '#F8F9FA',
                  p: 3,
                  borderTop: '1px solid #EAEAEA',
                }}
              >
                <Typography
                  variant='body2'
                  sx={{ color: '#4A5568', lineHeight: 1.6, whiteSpace: 'pre-line' }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        {/* Falar com o suporte */}
        <Box
          sx={{
            mt: 6,
            bgcolor: '#042235',
            borderRadius: '16px',
            p: 4,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3,
          }}
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 3 }}
          >
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <HeadsetMicOutlined sx={{ color: '#fff', fontSize: 32 }} />
            </Box>
            <Box>
              <Typography
                variant='h5'
                fontWeight='800'
                sx={{ color: '#fff', mb: 0.5 }}
              >
                Não encontrou o que procura?
              </Typography>
              <Typography
                variant='body2'
                sx={{ color: '#B0C4DF', fontSize: '0.9rem' }}
              >
                Nossa equipe está pronta para apoiar você. Entre em contato com o suporte.
              </Typography>
            </Box>
          </Box>

          <Button
            variant='outlined'
            component='a'
            href='mailto:suportesaf@4controlgroup.com'
            sx={{
              borderColor: 'rgba(255,255,255,0.3)',
              color: '#fff',
              borderRadius: '12px',
              px: 4,
              py: 1.5,
              fontWeight: 'bold',
              textTransform: 'none',
              whiteSpace: 'nowrap',
              '&:hover': {
                borderColor: '#fff',
                bgcolor: 'rgba(255,255,255,0.05)',
              },
            }}
          >
            Falar com o suporte
          </Button>
        </Box>
      </Container>
    </Box>
    </Fade>
  );
};

export default CentralAjudaPage;
